import {Component, Input, ViewChild, Output, EventEmitter} from '@angular/core';
import {SelectItem} from 'primeng/api';
import {EdaDialogAbstract, EdaDialog, EdaDialogCloseEvent, EdaDatePickerComponent} from '@eda/shared/components/shared-components.index';
import {Column} from '@eda/models/model.index';
import { CommonModule } from '@angular/common';
import { NgClass } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip'; 
import { InputSwitchModule } from 'primeng/inputswitch';

import { AlertService, ChartUtilsService, ColumnUtilsService, DashboardService, FilterType, QueryBuilderService, } from '@eda/services/service.index';
import * as _ from 'lodash';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';  // <-- necesario para ngModel
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { MultiSelectModule } from 'primeng/multiselect';
import { DropdownModule } from 'primeng/dropdown';
import { EdaDialog2Component } from '@eda/shared/components/shared-components.index';
import { aggTypes } from 'app/config/aggretation-types';

const ANGULAR_MODULES = [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    NgClass,
    MultiSelectModule,
    ScrollPanelModule
];

const PRIMENG_MODULES = [
    DropdownModule,
    InputSwitchModule,
    TooltipModule
];

const STANDALONE_COMPONENTS = [
    EdaDialog2Component,
    EdaDatePickerComponent
];


@Component({
    standalone: true,
    selector: 'app-filter-dialog',
    templateUrl: './filter-dialog.component.html',
    styleUrls: ['../eda-blank-panel.component.css','./filter-dialog.component.css'],
    imports: [STANDALONE_COMPONENTS, ANGULAR_MODULES, PRIMENG_MODULES]

})

export class FilterDialogComponent {

    @ViewChild('myCalendar', { static: false }) datePicker: EdaDatePickerComponent;
    @Output() updateSortedFiltersFilterDialog: EventEmitter<any> = new EventEmitter<any>();    

    @Input() controller: any;

    public dialog: EdaDialog;
    public selectedColumn: Column;
    public loading: boolean = true;
    public title: string;
    public displayWindow: boolean = false;
    public display = {
        between: false,
        calendar: false,
        filterValue: false,
        filterButton: true,
        switchButton: true
    };
    public filter = {
        switch: false,
        types: [],
        forDisplay: [],
        selecteds: [],
        range : null
    };
    public filterBeforeAfter = {
        filterBeforeGrouping: true, // valor por defecto true ==> WHERE / valor false ==> HAVING
        elements: [
            {label: 'Aplicar el filtro sobre todos los registros.', value: true}, // WHERE
            {label: 'Aplicar el filtro sobre los resultados.', value: false}, // HAVING
        ],
    }
    public filterBeforeAfterSelected: any;
    public inputType: string;
    public filterValue: any = {};
    public filterSelected: FilterType;
    public dropDownFields: SelectItem[] = [];
    public limitSelectionFields: number;
    public aggregationsTypes: any[] = [];
    public aggregationType: any = null;

    // Tooltip
    public whereMessage: string = $localize`:@@whereMessage: Filtro sobre todos los registros`;
    public havingMessage: string = $localize`:@@havingMessage: Filtro sobre los resultados`;
    public textBetween: string = $localize`:@@textBetween:Entre`

    constructor(
        private dashboardService: DashboardService,
        private chartUtils: ChartUtilsService,
        private columnUtils: ColumnUtilsService,
        private queryBuilder: QueryBuilderService,
        private alertService: AlertService
    ) {

        this.filter.types = this.chartUtils.filterTypes;
        this.filterBeforeAfterSelected = this.filterBeforeAfter.elements[0];
    }

    ngOnInit(): void {
        this.selectedColumn = this.controller.params.selectedColumn;
        this.title = `Atributo ${this.selectedColumn.display_name.default} de la entidad ${this.controller.params.table}`;
        this.carrega();
    }

    addFilter() {
        const table = this.selectedColumn.table_id;
        const column_type  = this.selectedColumn.column_type;
        const column = this.selectedColumn.column_name;
        const type = this.filterSelected.value;
        const selectedRange = this.filter.range;
        const valueListSource = this.selectedColumn.valueListSource;
        const joins = this.selectedColumn.joins;
        const autorelation = this.selectedColumn.autorelation;
        const filterBeforeGrouping = this.filterBeforeAfter.filterBeforeGrouping
        const aggregation_type = this.aggregationType ? this.aggregationType.value : null;
        const data = this.dropDownFields;
        
        const filter = this.columnUtils.setFilter({
            obj: this.filterValue,
            table,
            column,
            column_type,
            type,
            selectedRange,
            valueListSource,
            autorelation,
            joins,
            filterBeforeGrouping,
            aggregation_type,
            data,
        });
        
        this.filter.selecteds.push(filter);

        this.carregarFilters();

        /* Reset Filter Form */
        this.resetDisplay();
        this.filterSelected = undefined; // filtre seleccionat cap
        this.filterValue = {}; // filtre ningun
        this.filter.range = null;
        this.filterBeforeAfter.filterBeforeGrouping = true;
        this.filterBeforeAfterSelected = this.filterBeforeAfter.elements[0]
        this.aggregationType = {display_name: 'Suma', value: 'sum', selected: true};

        // Control de agregar solo el filtro en la sección Where
        const addToSortedFilters = { add: true, filter: filter };
        if(filter['filterBeforeGrouping']) this.updateSortedFiltersFilterDialog.emit(addToSortedFilters);        
    }

    carrega() {
        this.applyFilterTypesByColumn();
        this.carregarFilters();
        this.handleInputTypes();
        this.handleAggregationType();
    }

    private applyFilterTypesByColumn(): void {
        const exclude: Record<string, string[]> = {
            numeric: ['like', 'not_like'],
            date:    ['like', 'not_like'],
            text:    ['>', '<', '>=', '<=', 'between'],
        };
        const toExclude = exclude[this.selectedColumn.column_type] ?? [];
        if (toExclude.length) {
            this.filter.types = this.filter.types.filter((t: any) => !toExclude.includes(t.value));
        }
    }

    handleInputTypes() {
        const type = this.selectedColumn.column_type;
        this.inputType = this.columnUtils.handleInputTypes(type);
    }

    handleAggregationType() {

        this.aggregationsTypes = JSON.parse(JSON.stringify(this.selectedColumn.aggregation_type));

        for (let agg of this.aggregationsTypes) {
            if(agg.value === 'sum') {
                agg.selected = true;
                this.aggregationType = agg; // Obtenemos la agregación por default
            } else {
                agg.selected = false;
            }
        }

        // La agregacion none, esta descartada
        this.aggregationsTypes.pop();

    }
    
    addAggregation(type: any) {

        // Seleccionando la agregación
        this.aggregationsTypes.find((ag:any) => ag.value === type.value).selected = true;

        for (let ag of this.aggregationsTypes) {
            if (ag.selected === true && type.value !== ag.value) {
                ag.selected = false;
            }
        }

        // Recarguem les agregacions d'aquella columna + la seleccionada
        this.selectedColumn.aggregation_type = JSON.parse(JSON.stringify(this.aggregationsTypes));

        // Obteniendo la agregación seleccionada
        this.aggregationType = _.cloneDeep(type);

    }

    getAggName(value: string) {
        return aggTypes.filter(agg => agg.value === value)[0].label;
    }

    getAggregationText(value: any) {
        const label = aggTypes.filter(agg => {
            return (agg.value === value.aggregation_type);
        })[0].label;
        return label;
    }

    getFilterText(value) {
        if(value.filter_type === 'between') return this.textBetween;
        return value.filter_type;
    }

    carregarFilters() {
        this.filter.selecteds = this.controller.params.filters;
        this.filter.forDisplay = this.filter.selecteds.filter(f =>
            f.filter_table === this.selectedColumn.table_id &&
            f.filter_column === this.selectedColumn.column_name &&
            !f.removed
        );
        
    }


    removeFilter(item: any) {
        const addToSortedFilters = { add: false, filter: item };
        this.updateSortedFiltersFilterDialog.emit(addToSortedFilters);

        this.filter.selecteds.find(f => _.startsWith(f.filter_id, item.filter_id) ).removed = true;

        this.filter.forDisplay = this.filter.selecteds.filter(f => {
            return _.startsWith(f.filter_table, this.selectedColumn.table_id) &&
                _.startsWith(f.filter_column, this.selectedColumn.column_name) &&
                !f.removed;
        });
    }

    handleValidForm(event) {
        if (!this.display.between) {
            this.filterValue = {};
        }
        const validators = {
            between: this.display.between,
            value: this.display.filterValue,
            selected: this.filterSelected,
        };
        this.display.filterButton = this.columnUtils.handleValidForm(event, this.filterValue, validators);
    }

    handleFilterChange(filter: FilterType) {
        if (filter) {
            const handler = this.columnUtils.handleFilterChange(filter);
            this.display.between = handler.between;
            this.display.filterValue = !_.isEqual(this.selectedColumn.column_type, 'date') ? handler.value : false;
            this.display.calendar = _.isEqual(this.selectedColumn.column_type, 'date') ? handler.value : false;
            this.display.switchButton = _.isEqual(filter.value, 'not_null') || _.isEqual(filter.value, 'not_null_nor_empty') || _.isEqual(filter.value, 'null_or_empty') ? true : false ;
            this.display.filterButton = filter.value == 'not_null' || filter.value == 'not_null_nor_empty' || filter.value == 'null_or_empty' ? false : true ;
            this.limitSelectionFields = handler.limitFields === 1 ? 1 : 50;
            this.filter.switch = handler.switchBtn;

            if (handler.switchBtn) {
                this.loadDropDrownData();
                this.display.switchButton = true;
            }

            if ( !_.isEqual(filter.value, 'between') ) {
                this.filterValue = {};
            }
            if(['in', 'not_in', 'not_null', 'not_null_nor_empty', 'null_or_empty'].includes(filter.value)) {
                this.whereHavingSwitch({
                    label: 'WHERE',
                    value: true,
                })
                this.filterBeforeAfterSelected = {label: 'WHERE', value: true}
            }
        } else {
            this.resetDisplay();
        }
    }

    resetDisplay() {
        this.display.filterButton = true; // btn add filter
        this.display.between = false; // inputs between
        this.display.filterValue = false; // input de valor
        this.display.calendar = false; // input calendar
        this.display.switchButton = true;
        this.filter.switch = false; // options switch
    }

    async loadDropDrownData() {
        this.filterValue.value1 = null;
        this.filterValue.value2 = null;
        this.dropDownFields = [];
        if (this.filter.switch) {
            const column = _.cloneDeep(this.selectedColumn);
            column.table_id = column.table_id.split('.')[0];
            column.joins = [];
            column.ordenation_type = 'Asc';

            const params = {
                table: column.table_id,
                dataSource: this.controller.params.inject.dataSource._id,
                dashboard: this.controller.params.inject.dashboard_id,
                panel: this.controller.params.panel._id,
                connectionProperties: this.controller.params.connectionProperties,
                filters: [],
                forSelector: true
            };

            try {
                const res = await this.dashboardService.executeQuery(this.queryBuilder.normalQuery([column], params)).toPromise();
            
                if (res.length > 1) {
                    for (const item of res[1]) {
                        if (item[0] === '' || item[0] ) { 
                            this.dropDownFields.push({ label : item[0], value: item[0] });
                        }
                    }
                }
            } catch (err) {
                this.alertService.addError(err);
                throw err;
            }
        }
        this.loading = false;
    }

    whereHavingSwitch(selected) {

        if(selected.value) {
            this.filterBeforeAfter.filterBeforeGrouping = true;
            return true
        } else {
            this.filterBeforeAfter.filterBeforeGrouping = false;
            return false
        }

    }

    processPickerEvent(event){
        if (event.dates) {
            const dtf = new Intl.DateTimeFormat('en', { year: 'numeric', month: '2-digit', day: '2-digit' });
            const singleValueOperators = ['=', '!=', '>', '<', '>=', '<='];
            const isSingleDate = singleValueOperators.includes(this.filterSelected?.value);

            const dates = Array.isArray(event.dates) ? event.dates : [event.dates, event.dates];
            if (!dates[1]) dates[1] = dates[0];

            let stringRange = [dates[0], dates[1]]
                .map(date => {
                    let [{ value: mo }, , { value: da }, , { value: ye }] = dtf.formatToParts(date);
                    return `${ye}-${mo}-${da}`
                });

            this.filter.range = event.range;
            this.filterValue.value1 = stringRange[0];
            this.filterValue.value2 = isSingleDate ? null : stringRange[1];
            this.display.filterButton = false;
        }
    }

    closeDialog() {
        this.filter.switch = false;
        this.filterSelected = undefined;
        this.filterValue = {};
        this.onClose(EdaDialogCloseEvent.NONE, this.filter.selecteds);
    }

    onClose(event: EdaDialogCloseEvent, response?: any): void {
        return this.controller.close(event, response);
    }

    onApply(){
        this.closeDialog();
    }
}
